import { Button } from '@carboncopyco/ui';
import { useWorkspaceManageTag } from './WorkspaceManageTagContext';

export const WorkspaceManageTagControls = () => {
  const { submit, isDirty } = useWorkspaceManageTag();
  return (
    <div className="flex justify-end items-center w-full">
      <Button
        label="Save tags"
        onClick={submit}
        disabled={!isDirty}
      />
    </div>
  );
};
